import React, { useState, useEffect } from "react";
import { auth } from "./firebase";
import {
  sendSignInLinkToEmail,
  isSignInWithEmailLink,
  signInWithEmailLink
} from "firebase/auth";
import { useTranslation } from "react-i18next";

const actionCodeSettings = {
  url: window.location.href,
  handleCodeInApp: true,
};

export default function Login() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [isCompleting, setIsCompleting] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    if (isSignInWithEmailLink(auth, window.location.href)) {
      const savedEmail = window.localStorage.getItem("emailForSignIn");

      if (savedEmail) {
        signInWithEmailLink(auth, savedEmail, window.location.href)
          .then(() => {
            window.localStorage.removeItem("emailForSignIn");
          })
          .catch(() => {
            setMessage("This link has expired or is invalid.");
            const url = new URL(window.location.href);
            url.search = "";
            window.history.replaceState({}, document.title, url.toString());
          });
      } else {
        setIsCompleting(true);
      }
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isCompleting) {
      try {
        await signInWithEmailLink(auth, email, window.location.href);
        setMessage(t("signedInSuccess"));
      } catch (err) {
        setMessage(err.message);
      }
    } else {
      try {
        await sendSignInLinkToEmail(auth, email, actionCodeSettings);
        window.localStorage.setItem("emailForSignIn", email);
        setMessage(t("loginLinkSent"));
      } catch (err) {
        setMessage(err.message);
      }
    }
  };

  return (
    <div className="content-wrapper">
      <div className="welcome-message">
        <h2>{t("welcome")}</h2>
        <p>
          {t("welcomeMessage")}
        </p>
      </div>

      <h2>{isCompleting ? t("completeSignIn") : t("signIn")}</h2>

      <form className="login-form" onSubmit={handleSubmit}>
        <input
          type="email"
          value={email}
          required
          placeholder={t("emailPlaceholder")}
          onChange={(e) => setEmail(e.target.value)}
        />
        <button type="submit">
          {isCompleting ? t("finishSignIn") : t("sendLoginLink")}
        </button>
      </form>

      {message && <p className="status-message">{message}</p>}
    </div>

  );
}
